import { Dialog } from 'primereact/dialog'
import styled from 'styled-components'

export const StyledDialog = styled(Dialog)`
    display: flex;
    min-width: 400px;
    position: fixed;
    top: 25vh;
`

export const FooterContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`
